import { UserUpsellNotificationDetail } from "../types/upsell-notification/UserUpsellNotificationDetail";
import { axiosWithAuth } from "../utils/customAxios";

export interface UpsellNotificationResponse {
    status: string;
    notifications: UserUpsellNotificationDetail[];
}

const upsellNotification = {
    getNotificationsToShow: async (userId: number): Promise<UpsellNotificationResponse>=> {
        try {
            const response = await axiosWithAuth.get(`/user/${userId}/upsellNotification`);
            return response.data;
        } catch (err) {
            throw err;
        }
    },
    updateNotificationHistory: async (
        userId: number,
        upsellNotificationHistoryId: number,
        options: { isUpsellNotificationSuppressed?: boolean; markAsShown?: boolean }
    ): Promise<void> => {
        try {
            const response = await axiosWithAuth.put(
                `/user/${userId}/${upsellNotificationHistoryId}/upsellNotification`,
                {
                    isUpsellNotificationSuppressed: options.isUpsellNotificationSuppressed,
                    markAsShown: options.markAsShown,
                }
            );
             return response.data.status;
        } catch (err) {
            throw err;
        }
    },
}

export default upsellNotification;